<template>
<div class="riots-table">
    <table>
        <col class="c1" :style="'width:'+(100 / (riots.length + 1))+'%'">
        <col 
            v-for="(riot, riot_index) in riots" :key="riot_index"
            :class="'c'+(riot_index + 2)"
            :style="'width:'+(100 / (riots.length + 1))+'%'"
            >
        <thead>
            <tr>
                <th></th>
                <th v-for="(riot, riot_index) in riots" :key="riot_index" v-html="riot.name"></th>
            </tr>
        </thead>
        <tbody>
            <tr 
                v-for="(row, row_index) in rows" 
                :key="row_index" 
                :class="[{'header' : isHeader(row) }]">
                <td v-html="row"></td>
                <td 
                    v-for="(riot, riot_index) in riots" 
                    :key="riot_index"
                    :class="[{'long':riotContent(riot_index, row_index).length > 10}]">
                    <span 
                        @click="openPopup(riot_index, row_index)" 
                        @mouseover="openPopup(riot_index, row_index, 'row_'+row_index+'_riot_'+riot_index)" 
                        @mouseout="closePopup()"
                        :class="[
                        {'has_notes_or_source': hasNotesOrSource(riot_index, row_index)},
                        'row_'+row_index+'_riot_'+riot_index
                        ]" 
                        v-html="riotContent(riot_index, row_index)"
                        :rel="'row_'+row_index+'_riot_'+riot_index"
                        :ref="'row_'+row_index+'_riot_'+riot_index"
                        ></span>
                    <a @click="readmore_click(riot_index, row_index)" class="readmore">Read More</a>
                </td>
            </tr>
        </tbody>
    </table>
    <div class="popup" :class="{'visible': popup_visible}" :style="popup_styles"
        @mouseover="onPopUp" 
        @mouseout="outOfPopup"
        ref="popup"
        >
        <div class="close" @click="closePopupNow()">X</div>
        <div class="notes" v-if="riotContent(popup_riot_index, popup_row_index, 'notes')">
            <span class="title">Note/Detail: </span>
            <span v-html="urlify(riotContent(popup_riot_index, popup_row_index, 'notes'))"></span>
        </div>
        <div class="sources" v-if="riotContent(popup_riot_index, popup_row_index, 'sources')">
            <span class="title">Source(s): </span>
            <span v-html="urlify(riotContent(popup_riot_index, popup_row_index, 'sources'))"></span>
        </div>
    </div>
</div>
</template>

<script>

/** 
 * @see https://github.com/launchcodedev/toml-loader
 * @see https://www.toml-lint.com/
 */
import table_data from './table_data.toml';
// console.log("TABLE DATA", table_data);

/**
 * @see https://alexcorvi.github.io/anchorme.js/
 */
import anchorme from "anchorme";

export default {
    data : function() {
        return {
            riots : [],
            popup_visible: false,
            popup_riot_index: 0,
            popup_row_index: 0,
            rows : [
                "",
                "Key Facts & Figures",
                "Casualties",
                "— Police Officers Killed",
                "— Police Officers Assaulted/&#8203;Injured",
                "— Non-Officers Killed",   
                "Arrests",     
                "Federal Charges", 
                "— Assault",
                "— Weapons",               
                "Estimated Damages",
                "Pretrial Detention",
                "Pretrial Detention Duration",
                "Case Outcomes",
                "Additional Details",
                "Government Classification",
                "Organizations Implicated",
                "Duration",
                "Scope",        
                "Incidents (excluding Killings, Assaults)",
                //"— Murder(s)",
                //"— Assaults",
                "— Explosions",
                "— Gunshots from Participants",
                "— Arson",
                "— Looting",
                "— Defacing Public and/or Private Property",
                "— Occupying Streets",
                "— Impeding Traffic",
                "— Vehicular Crimes",        
                "Dangerous Weapons Encountered",
                "Notable Protester Tactics",
                "Damage Description",        
                "Investigative/Prosecutorial Rigor", 
                "Alleged Malfeasance",        
                "Fallout",        
            ],
            cache_bust : Math.floor((new Date()).getTime() / 25000), // Changes every 25 seconds

            current_el_ref: null,
            close_timeout_popup: null,
            popup_styles: '',
        };
    },
    created : function() {
        this.load_toml();
    },
    mounted : function() {
        this.init_readmore();
    },
    methods : {
      
        load_toml : function() {
  
            // this.getCORS("table_v5.toml", (request) => {
    
            // var response = request.currentTarget.response || request.target.responseText;
            // var data = toml.parse(response);

            // var data = toml.parse(table_data);
            
            this.riots = table_data.riots;
    
            // });
        },
  
        init_readmore : function() {
  
            this.addEvent(window, "resize", this.readmore_check);
  
            // Do once without any resize
            // Wait a few milliseconds to have elements rendered
            // Tried this with a vue tick but no luck.
            setTimeout(() => {
                this.readmore_check();
            }, 1000);
        },
  
        readmore_check : function() {
  
            for(var i = 0; i < this.rows.length; i++) {
                var row_index = i;
                for(var j = 0; j < this.riots.length; j++) {
                    var riot_index = j;
  
                    var el = document.querySelector('.riots-table span.row_'+row_index+'_riot_'+riot_index);
  
                    if(el) {
                        if(el.scrollHeight > el.clientHeight + 2) { // Buffer of 2 pixels seems to make it work
                            this.addClass(el.parentElement, "readmore");
                        } else {
                            this.removeClass(el.parentElement, "readmore");
                        }
                    }
                }
            }
        },
  
        readmore_click : function(riot_index, row_index) {
  
            var el = document.querySelector('.riots-table span.row_'+row_index+'_riot_'+riot_index);
    
            console.log(el);
            this.addClass(el.parentElement, 'open');
        },
  
        addEvent : function(object, type, callback) {
            if (object == null || typeof(object) == 'undefined') return;
            if (object.addEventListener) {
                object.addEventListener(type, callback, false);
            } else if (object.attachEvent) {
                object.attachEvent("on" + type, callback);
            } else {
                object["on"+type] = callback;
            }
        },
  
        hasClass : function(el, className) {
            return el.classList ? el.classList.contains(className) : new RegExp('\\b'+ className+'\\b').test(el.className);
        },
  
        addClass : function(el, className) {
            if (el.classList) el.classList.add(className);
            else if (!this.hasClass(el, className)) el.className += ' ' + className;
        },
  
        removeClass : function(el, className) {
            if (el.classList) el.classList.remove(className);
            else el.className = el.className.replace(new RegExp('\\b'+ className+'\\b', 'g'), '');
        },
  
    //   closePopup : function() {
    //     this.popup_visible = false;
    //   }
  
        getCORS : function(url, success) {
            var xhr = new XMLHttpRequest();
            if (!('withCredentials' in xhr)) xhr = new XDomainRequest(); // fix IE8/9
            xhr.open('GET', url);
            xhr.onload = success;
            xhr.send();
            return xhr;
        },
  
        riotContent : function(riot_index, row_index, content_type) {
  
            var r = this.riots[riot_index];
            var row = this.rows[row_index];
  
            if(typeof content_type === 'undefined') {
                content_type = 'content';
            }
            if(content_type == 'notes' && typeof r.notes === 'undefined') {
                return "";
            }
            if(content_type == 'sources' && typeof r.sources === 'undefined') {
                return "";
            }
  
            switch(row) {
    
                case "Duration" :
                    switch (content_type) {
                        case "content": return typeof r.duration !== 'undefined' ? r.duration : "";
                        case "notes":   return typeof r.notes.duration !== 'undefined' ? r.notes.duration : "";
                        case "sources": return typeof r.sources.duration !== 'undefined' ? r.sources.duration : "";
                        default: return "";
                    }
                break;
                case "Scope" :
                    switch (content_type) {
                        case "content": return typeof r.scope !== 'undefined' ? r.scope : "";
                        case "notes":   return typeof r.notes.scope !== 'undefined' ? r.notes.scope : "";
                        case "sources": return typeof r.sources.scope !== 'undefined' ? r.sources.scope : "";
                        default: return "";
                    }
                break;
                case "Organizations Implicated" :
                    switch (content_type) {
                        case "content": return typeof r.org_impl !== 'undefined' ? r.org_impl : "";
                        case "notes":   return typeof r.notes.org_impl !== 'undefined' ? r.notes.org_impl : "";
                        case "sources": return typeof r.sources.org_impl !== 'undefined' ? r.sources.org_impl : "";
                        default: return "";
                    }
                break;
                case "— Murder(s)" :
                    switch (content_type) {
                        case "content": return typeof r.incidents !== 'undefined' && r.incidents.murder ? "X" : "";
                        case "notes":   return typeof r.notes.incidents !== 'undefined' ? r.notes.incidents.murder : "";
                        case "sources": return typeof r.sources.incidents !== 'undefined' ? r.sources.incidents.murder : "";
                        default: return "";
                    }
                break;
                case "— Assaults" :
                    switch (content_type) {
                        case "content": return typeof r.incidents !== 'undefined' && r.incidents.assaults ? "X" : "";
                        case "notes":   return typeof r.notes.incidents !== 'undefined' ? r.notes.incidents.assaults : "";
                        case "sources": return typeof r.sources.incidents !== 'undefined' ? r.sources.incidents.assaults : "";
                        default: return "";
                    }
                break;
                case "— Explosions" :
                    switch (content_type) {
                        case "content": return typeof r.incidents !== 'undefined' && r.incidents.explosions ? "X" : "";
                        case "notes":   return typeof r.notes.incidents !== 'undefined' ? r.notes.incidents.explosions : "";
                        case "sources": return typeof r.sources.incidents !== 'undefined' ? r.sources.incidents.explosions : "";
                        default: return "";
                    }
                break;
                case "— Gunshots from Participants" :
                    switch (content_type) {
                        case "content": return typeof r.incidents !== 'undefined' && r.incidents.gunshots_from_participants ? "X" : "";
                        case "notes":   return typeof r.notes.incidents !== 'undefined' ? r.notes.incidents.gunshots_from_participants : "";
                        case "sources": return typeof r.sources.incidents !== 'undefined' ? r.sources.incidents.gunshots_from_participants : "";
                        default: return "";
                    }
                break;
                case "— Arson" :
                    switch (content_type) {
                        case "content": return typeof r.incidents !== 'undefined' && r.incidents.arson ? "X" : "";
                        case "notes":   return typeof r.notes.incidents !== 'undefined' ? r.notes.incidents.arson : "";
                        case "sources": return typeof r.sources.incidents !== 'undefined' ? r.sources.incidents.arson : "";
                        default: return "";
                    }
                break;
                case "— Looting" :
                    switch (content_type) {
                        case "content": return typeof r.incidents !== 'undefined' && r.incidents.looting ? "X" : "";
                        case "notes":   return typeof r.notes.incidents !== 'undefined' ? r.notes.incidents.looting : "";
                        case "sources": return typeof r.sources.incidents !== 'undefined' ? r.sources.incidents.looting : "";
                        default: return "";
                    }
                break;
                case "— Defacing Public and/or Private Property" :
                    switch (content_type) {
                        case "content": return typeof r.incidents !== 'undefined' && r.incidents.defacing ? "X" : "";
                        case "notes":   return typeof r.notes.incidents !== 'undefined' ? r.notes.incidents.defacing : "";
                        case "sources": return typeof r.sources.incidents !== 'undefined' ? r.sources.incidents.defacing : "";
                        default: return "";
                    }
                break;
                case "— Occupying Streets" :
                    switch (content_type) {
                        case "content": return typeof r.incidents !== 'undefined' && r.incidents.occupying_streets ? "X" : "";
                        case "notes":   return typeof r.notes.incidents !== 'undefined' ? r.notes.incidents.occupying_streets : "";
                        case "sources": return typeof r.sources.incidents !== 'undefined' ? r.sources.incidents.occupying_streets : "";
                        default: return "";
                    }
                case "— Impeding Traffic" :
                    switch (content_type) {
                        case "content": return typeof r.incidents !== 'undefined' && r.incidents.impeding_traffic ? "X" : "";
                        case "notes":   return typeof r.notes.incidents !== 'undefined' ? r.notes.incidents.impeding_traffic : "";
                        case "sources": return typeof r.sources.incidents !== 'undefined' ? r.sources.incidents.impeding_traffic : "";
                        default: return "";
                    }
                break;
                case "— Vehicular Crimes" :
                    switch (content_type) {
                        case "content": return typeof r.incidents !== 'undefined' && r.incidents.vehicular ? "X" : "";
                        case "notes":   return typeof r.notes.incidents !== 'undefined' ? r.notes.incidents.vehicular : "";
                        case "sources": return typeof r.sources.incidents !== 'undefined' ? r.sources.incidents.vehicular : "";
                        default: return "";
                    }
                break;
                case "Government Classification" :
                    switch (content_type) {
                        case "content": return typeof r.gov_class !== 'undefined' ? r.gov_class : "";
                        case "notes":   return typeof r.notes.gov_class !== 'undefined' ? r.notes.gov_class : "";
                        case "sources": return typeof r.sources.gov_class !== 'undefined' ? r.sources.gov_class : "";
                        default: return "";
                    }
                break;
                case "Arrests" :
                    switch (content_type) {
                        case "content": return typeof r.arrests !== 'undefined' ? r.arrests : "";
                        case "notes":   return typeof r.notes.arrests !== 'undefined' ? r.notes.arrests : "";
                        case "sources": return typeof r.sources.arrests !== 'undefined' ? r.sources.arrests : "";
                        default: return "";
                    }
                break;
                case "Dangerous Weapons Encountered" :
                    switch (content_type) {
                        case "content": return typeof r.weapons_used !== 'undefined' ? r.weapons_used : "";
                        case "notes":   return typeof r.notes.weapons_used !== 'undefined' ? r.notes.weapons_used : "";
                        case "sources": return typeof r.sources.weapons_used !== 'undefined' ? r.sources.weapons_used : "";
                        default: return "";
                    }
                break;
                case "Notable Protester Tactics" :
                    switch (content_type) {
                        case "content": return typeof r.notable_tactics !== 'undefined' ? r.notable_tactics : "";
                        case "notes":   return typeof r.notes.notable_tactics !== 'undefined' ? r.notes.notable_tactics : "";
                        case "sources": return typeof r.sources.notable_tactics !== 'undefined' ? r.sources.notable_tactics : "";
                        default: return "";
                    }
                break;
                case "Damage Description" :
                    switch (content_type) {
                        case "content": return typeof r.damage_description !== 'undefined' ? r.damage_description : "";
                        case "notes":   return typeof r.notes.damage_description !== 'undefined' ? r.notes.damage_description : "";
                        case "sources": return typeof r.sources.damage_description !== 'undefined' ? r.sources.damage_description : "";
                        default: return "";
                    }
                break;
                case "— Police Officers Killed" :
                    switch (content_type) {
                        case "content": return typeof r.police_officers_killed !== 'undefined' ? r.police_officers_killed : "";
                        case "notes":   return typeof r.notes.police_officers_killed !== 'undefined' ? r.notes.police_officers_killed : "";
                        case "sources": return typeof r.sources.police_officers_killed !== 'undefined' ? r.sources.police_officers_killed : "";
                        default: return "";
                    }
                break;
                case "— Non-Officers Killed" :
                    switch (content_type) {
                        case "content": return typeof r.civilians_killed !== 'undefined' ? r.civilians_killed : "";
                        case "notes":   return typeof r.notes.civilians_killed !== 'undefined' ? r.notes.civilians_killed : "";
                        case "sources": return typeof r.sources.civilians_killed !== 'undefined' ? r.sources.civilians_killed : "";
                        default: return "";
                    }
                break;
                case "— Police Officers Assaulted/&#8203;Injured":
                    switch (content_type) {
                        case "content": return typeof r.police_officers_assaulted_injured !== 'undefined' ? r.police_officers_assaulted_injured : "";
                        case "notes":   return typeof r.notes.police_officers_assaulted_injured !== 'undefined' ? r.notes.police_officers_assaulted_injured : "";
                        case "sources": return typeof r.sources.police_officers_assaulted_injured !== 'undefined' ? r.sources.police_officers_assaulted_injured : "";
                        default: return "";
                    }
                break;
                case "— Civilians Assaulted/Injured" :
                    switch (content_type) {
                        case "content": return typeof r.civilians_assulted_injured !== 'undefined' ? r.civilians_assulted_injured : "";
                        case "notes":   return typeof r.notes.civilians_assulted_injured !== 'undefined' ? r.notes.civilians_assulted_injured : "";
                        case "sources": return typeof r.sources.civilians_assulted_injured !== 'undefined' ? r.sources.civilians_assulted_injured : "";
                        default: return "";
                    }
                break;
                case "Investigative/Prosecutorial Rigor" :
                    switch (content_type) {
                        case "content": return typeof r.investigative_rigor !== 'undefined' ? r.investigative_rigor : "";
                        case "notes":   return typeof r.notes.investigative_rigor !== 'undefined' ? r.notes.investigative_rigor : "";
                        case "sources": return typeof r.sources.investigative_rigor !== 'undefined' ? r.sources.investigative_rigor : "";
                        default: return "";
                    }
                break;
                case "Alleged Malfeasance" :
                    switch (content_type) {
                        case "content": return typeof r.alleged_malfeasance !== 'undefined' ? r.alleged_malfeasance : "";
                        case "notes":   return typeof r.notes.alleged_malfeasance !== 'undefined' ? r.notes.alleged_malfeasance : "";
                        case "sources": return typeof r.sources.alleged_malfeasance !== 'undefined' ? r.sources.alleged_malfeasance : "";
                        default: return "";
                    }
                break;
                case "Estimated Damages" :
                    switch (content_type) {
                        case "content": return typeof r.damages !== 'undefined' ? r.damages : "";
                        case "notes":   return typeof r.notes.damages !== 'undefined' ? r.notes.damages : "";
                        case "sources": return typeof r.sources.damages !== 'undefined' ? r.sources.damages : "";
                        default: return "";
                    }
                break;
                case "— Assault" :
                    switch (content_type) {
                        case "content": return typeof r.charges !== 'undefined' ? r.charges.assault || "" : "";
                        case "notes":   return typeof r.notes.charges !== 'undefined' ? r.notes.charges.assault || "" : "";
                        case "sources": return typeof r.sources.charges !== 'undefined' ? r.sources.charges.assault || "" : "";
                        default: return "";
                    }
                break;
                case "— Weapons" :
                    switch (content_type) {
                        case "content": return typeof r.charges !== 'undefined' ? r.charges.weapons || "" : "";
                        case "notes":   return typeof r.notes.charges !== 'undefined' ? r.notes.charges.weapons || "" : "";
                        case "sources": return typeof r.sources.charges !== 'undefined' ? r.sources.charges.weapons || "" : "";
                        default: return "";
                    }
                break;
                /*case "— Guns" :
                    switch (content_type) {
                        case "content": return typeof r.charges !== 'undefined' ? r.charges.guns || "" : "";
                        case "notes":   return typeof r.notes.charges !== 'undefined' ? r.notes.charges.guns || "" : "";
                        case "sources": return typeof r.sources.charges !== 'undefined' ? r.sources.charges.guns || "" : "";
                        default: return "";
                    }
                break;
                case "— Conspiracy" :
                    switch (content_type) {
                        case "content": return typeof r.charges !== 'undefined' ? r.charges.conspiracy || "" : "";
                        case "notes":   return typeof r.notes.charges !== 'undefined' ? r.notes.charges.conspiracy || "" : "";
                        case "sources": return typeof r.sources.charges !== 'undefined' ? r.sources.charges.conspiracy || "" : "";
                        default: return "";
                    }
                break; */
                case "Pretrial Detention" :
                    switch (content_type) {
                        case "content": return typeof r.pretrial_detention !== 'undefined' ? r.pretrial_detention : "";
                        case "notes":   return typeof r.notes.pretrial_detention !== 'undefined' ? r.notes.pretrial_detention : "";
                        case "sources": return typeof r.sources.pretrial_detention !== 'undefined' ? r.sources.pretrial_detention : "";
                        default: return "";
                    }
                break;
                case "Pretrial Detention Duration" :
                    switch (content_type) {
                        case "content": return typeof r.pretrial_detention_duration !== 'undefined' ? r.pretrial_detention_duration : "";
                        case "notes":   return typeof r.notes.pretrial_detention_duration !== 'undefined' ? r.notes.pretrial_detention_duration : "";
                        case "sources": return typeof r.sources.pretrial_detention_duration !== 'undefined' ? r.sources.pretrial_detention_duration : "";
                        default: return "";
                    }
                break;        
                case "Sentences Sought" :
                    switch (content_type) {
                        case "content": return typeof r.sentences_sought !== 'undefined' ? r.sentences_sought : "";
                        case "notes":   return typeof r.notes.sentences_sought !== 'undefined' ? r.notes.sentences_sought : "";
                        case "sources": return typeof r.sources.sentences_sought !== 'undefined' ? r.sources.sentences_sought : "";
                        default: return "";
                    }
                break;
                case "Case Outcomes" :
                    switch (content_type) {
                        case "content": return typeof r.case_outcomes !== 'undefined' ? r.case_outcomes : "";
                        case "notes":   return typeof r.notes.case_outcomes !== 'undefined' ? r.notes.case_outcomes : "";
                        case "sources": return typeof r.sources.case_outcomes !== 'undefined' ? r.sources.case_outcomes : "";
                        default: return "";
                    }
                break;
            case "Fallout" :
                    switch (content_type) {
                        case "content": return typeof r.fallout !== 'undefined' ? r.fallout : "";
                        case "notes":   return typeof r.notes.fallout !== 'undefined' ? r.notes.fallout : "";
                        case "sources": return typeof r.sources.fallout !== 'undefined' ? r.sources.fallout : "";
                        default: return "";
                    }
                break;
        
        
                default:
        
                    if(row_index == 0 && r.image && content_type == 'content') {
                        return "<img class='riot-image' src='"+r.image+"' alt='"+r.name+"'>";
                    } else {
                        return "";
                    }
            }
        },
        isHeader : function(row) {
            return [
                'Key Facts & Figures',
                'Additional Details',
            ].includes(row);
        },
        hasNotesOrSource : function(riot_index, row_index){
            return this.riotContent(riot_index, row_index, 'notes') + this.riotContent(riot_index, row_index, 'sources') != '';
        },
        openPopup : function(riot_index, row_index, ref){
            console.log("REF", ref, this.$refs[ref], this.$refs[ref][0].getBoundingClientRect());

            if(!this.hasNotesOrSource(riot_index, row_index)) { 
                return;
            }

            this.current_el_ref = this.$refs[ref];
            this.popup_riot_index = riot_index;
            this.popup_row_index = row_index;
            this.popup_visible = true;
            clearTimeout(this.close_timeout_popup);
            this.popUpRefStyles();
        },

        closePopup: function(){

            clearTimeout(this.close_timeout_popup);

            this.close_timeout_popup = setTimeout(() => {
                this.popup_visible = false;
                this.current_el_ref = null;
            }, 250);
        },
      
        closePopupNow: function(){
            this.popup_visible = false;
            this.current_el_ref = null;
        },

        onPopUp: function(){
            this.popup_visible = true;
            clearTimeout(this.close_timeout_popup);
        },
        outOfPopup: function(){
            this.closePopup();
        },

        urlify: function (text) {
            return anchorme({
                input: text,
                options: {
                    attributes: {
                        target: "_blank",
                    }
                }
            });
        },

        /**
         * @see https://stackoverflow.com/questions/442404/retrieve-the-position-x-y-of-an-html-element-relative-to-the-browser-window
         * @see https://javascript.info/coordinates
         * @returns 
        */
       popUpRefStyles: function(){
           
            this.popup_styles = '';

            if( !this.current_el_ref ){
                return;
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    let rect = this.current_el_ref[0].getBoundingClientRect();
                    
                    let offset_height = 0;
                    let offset_width = 0;
                    // offset_height = this.current_el_ref[0].offsetHeight/2;
                    if(this.$refs.popup){
                        // offset_height   = offset_height + (this.$refs.popup.offsetHeight/4);
                        // offset_height   = offset_height + this.$refs.popup.offsetHeight;
                        offset_height   = this.$refs.popup.offsetHeight/2;
                        offset_width    = this.$refs.popup.offsetWidth/4;
                    }

                    console.log("CURRENT EL HEIGHT", this.current_el_ref[0].offsetHeight, "POPUP HEIGHT",this.$refs.popup.offsetHeight, "RECT Y", rect.y, "TOP", rect.y-offset_height, "OFFSET HEIGHT", offset_height, this.$refs.popup);
                    this.popup_styles = `left: ${rect.x + offset_width}px; top: ${rect.top-offset_height}px;`;
                }, 50);
            });
        },
    }
}
</script>

<style lang="scss">
.riots-table {
    font-size: 14px;
    border: 1px solid #747474;
}

@media only screen and (max-width: 767px) {
  .riots-table {
    overflow-x: auto;
  }
}
  .riots-table .popup {
    position: fixed;
    /* top: 50%;
    left: 50%; */
    background: white;
    border: 3px solid #747474;
    border-radius: 10px;
    max-width: 500px;
    /* max-width: 98vw; */
    padding: 10px 35px 10px 20px;
    line-height: 1.4;
    transform: translate(-50%, -50%);
    word-break: break-word;
    max-height: 75vh;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 1;
    visibility: hidden;
    opacity: 0;
    transition: opacity .25s ease-in-out;
  }
  .riots-table .popup.visible{
    visibility: visible;
    opacity: 1;
  }
  .riots-table .popup .title {
    font-weight: bold;
  }
  .riots-table .popup .notes,
  .riots-table .popup .sources {
    padding: 5px 0;
  }
  .riots-table .popup .close {
    font-family: sans-serif;
    color: white;
    background: #747474;
    position: absolute;
    top: -1px;
    right: -1px;
    padding: 5px 10px;
    border-top-right-radius: 9px;
    border-bottom-left-radius: 10px;
    cursor: pointer;
  }
  .riots-table .popup .close:hover {
    opacity: 0.75;
  }
  .alpha-long .article-body-text div.riots-table {
    margin: 0 calc((1180px - 750px) / 2 * -1);
    padding: 0;
  }
  .riots-table table {
    line-height: 1;
    border-collapse: collapse;
    text-align: center;

    position: relative;
  }
  .riots-table table thead th {
    padding: 8px 3px;
    background: #747474;
    color: white;
  }

  .riots-table th {
    position: sticky;
    top: 0; /* Don't forget this, required for the stickiness */
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
  }

  .riots-table table tbody tr th,
  .riots-table table tbody tr td {
    background: #fff;
  }
  .riots-table table tbody tr:nth-child(2n) th,
  .riots-table table tbody tr:nth-child(2n) td {
    background: #eee;
  }
  .riots-table table tbody tr.header td {
    background: #aaa;
    color: white;
    padding: 7px;
    font-weight: bold;
    font-size: 1.2em;
  }
  .riots-table table tbody td {
    padding: 2px 0;
  }
  .riots-table table tbody td:not(.open) > span {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .riots-table table tbody td.open a.readmore,
  .riots-table table tbody td a.readmore {
    display: none;
    cursor: pointer;
  }
  .riots-table table tbody td.readmore:not(.open) a.readmore {
    display: inline;
  }
  .riots-table table tbody td:first-child {
    text-align: left;
    padding-left: 3px;
  }
  .riots-table table tbody td.long {
    text-align: left;
  }
  .riots-table table tbody td span.has_notes_or_source {
    cursor: pointer;
    /*text-decoration: underline;*/
  }
  .riots-table table tbody td span.has_notes_or_source:hover {
    text-decoration: underline;
  }
  /*.riots-table table tbody td span.has_notes_or_source::after {
    content: '*';
  }*/
  .riots-table img.riot-image {
    width: 99%;
    height: 170px;
    object-fit: cover;
  }
  @media only screen and (max-width: 1180px) {
    .alpha-long .article-body-text > div.riots-table {
      margin: 0 calc(((100vw - var(--scrollbarWidth)) - 750px) / 2 * -1);
    }
  }
  @media only screen and (max-width: 1023px) {
    .riots-table img.riot-image {
      height: 90px;
    }
  }
  @media only screen and (max-width: 767px) {
    .alpha-long .article-body-text > div.riots-table {
      margin: 0;
    }
  }
  @media only screen and (max-width: 639px) {
  
    .riots-table table th:first-child,
    .riots-table table td:first-child {
      position: sticky;
      left: 0px;
    }
    .riots-table table {
      width: 550px;
    }
    .riots-table table col {
      width: 150px !important;
    }
    .riots-table table col.c1 {
      width: 100px !important;
    }
  }

#riots-table-container #cms-riots-table-display{
    display: none;
}
</style>